export const supportedLanguages = ['fr', 'en'];
export const fallbackLanguage = 'fr';
